/**
 * jgd-details-reveal — opens closed <details> ancestors so scroll targets
 * inside collapsed accordions are visible before the page scrolls to them.
 *
 * Covers:
 * 1. Judge.me's review-stars badge: a <span> with a JS scroll handler (no
 *    real anchor, no hash navigation), so the browser's native "ancestor
 *    details revealing" never runs. A capture-phase listener opens the
 *    accordion around #judgeme_product_reviews before Judge.me's own click
 *    handler measures the scroll position — its scroll then lands correctly.
 * 2. Generic in-page anchor links, hashchange, and initial load with a #hash,
 *    as a fallback for browsers/cases where native revealing doesn't apply.
 *
 * Loaded globally via snippets/scripts.liquid.
 */

const JUDGEME_BADGE = '.jdgm-prev-badge';
const JUDGEME_WIDGET_ID = 'judgeme_product_reviews';

/**
 * Opens every closed <details> ancestor of the target.
 * @param {Element | null} target
 */
function reveal(target) {
  let details = target?.closest('details');
  while (details) {
    details.open = true;
    details = details.parentElement?.closest('details');
  }
}

// Capture phase: runs before the default fragment navigation and before
// Judge.me's own (bubbling) click handler.
document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;

    if (event.target.closest(JUDGEME_BADGE)) {
      reveal(document.getElementById(JUDGEME_WIDGET_ID));
      return;
    }

    const anchor = event.target.closest('a[href^="#"]');
    if (anchor) {
      const id = decodeURIComponent(anchor.getAttribute('href').slice(1));
      if (id) reveal(document.getElementById(id));
    }
  },
  true
);

function revealFromHash() {
  const id = decodeURIComponent(location.hash.slice(1));
  if (id) reveal(document.getElementById(id));
}

window.addEventListener('hashchange', revealFromHash);
// Modules run after the DOM is parsed — safe to handle an initial #hash now.
revealFromHash();
